export const getHref = (name?: string) => (name ? `${process.env.NX_PUBLIC_CLOUD_PAYSEND_API}/consumer3/svg/${name}.svg#symb` : undefined);
